// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__17_ay","alertIcon":"ConfirmModal_alertIcon__3xmtT"};